import apiClient from './axios';

export const usageApi = {
  // Отримання всіх використань (для адміністратора)
  getAllUsages: () => {
    return apiClient.get('/usages');
  },
  
  // Отримання використання за ID
  getUsage: (id) => {
    return apiClient.get(`/usages/${id}`);
  },
  
  // Отримання використань користувача (без пагінації - для сумісності)
  getUserUsages: (userId) => {
    return apiClient.get(`/usages/user/${userId}`);
  },

  // Отримання використань користувача з пагінацією
  getUserUsagesPaginated: (userId, params = {}) => {
    return apiClient.get(`/usages/user/${userId}/paginated`, { params });
  },
  
  // Отримання використань знижки
  getDiscountUsages: (discountId) => {
    return apiClient.get(`/usages/discount/${discountId}`);
  },
  
  // Запис використання знижки
  recordUsage: (userId, discountId, savedAmount, notes, promoCodeId) => {
    return apiClient.post('/usages/record', null, {
      params: { userId, discountId, savedAmount, notes, promoCodeId }
    });
  },
  
  // Отримання загальної суми заощаджень користувача
  getTotalSavingsByUser: (userId) => {
    return apiClient.get(`/usages/user/${userId}/savings`);
  },

  // Адміністратор позначає використання знижки
  adminMarkUsed: (userId, discountId) => {
    return apiClient.post('/usages/admin/mark-used', null, {
      params: { userId, discountId }
    });
  },

  // Перевірити чи користувач використовував знижку
  checkUsage: (userId, discountId) => {
    return apiClient.get('/usages/check', {
      params: { userId, discountId }
    });
  }
};

export default usageApi;